import { Grid } from "@mui/material";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  let history = useNavigate();
  return (
    <Grid container sx={{ mt: "12px", textAlign: "center" }}>
      <Grid item xs>
        <Link
          onClick={() => history("/signin")}
          variant="body2"
          sx={{ fontSize: "16px" }}
        >
          Go back to sign in
        </Link>
      </Grid>
    </Grid>
  );
};

export default SignIn;
